import { notification as toast } from "antd"
import i18n from "i18next"

export const copieToClipboard = async (text: string) => {
  try {
    await navigator.clipboard.writeText(text)

    toast.success({
      message: i18n.t("global.copy_to_clipboard.success") as any,
    })
  } catch (error) {
    toast.error({
      message: i18n.t("global.copy_to_clipboard.error") as any,
    })
  }
}
